const variants = {
	next: ({ distribute, i }) => ({
		x: distribute(i)
	})
};

const swipeConfidenceThreshold = 10000;

const swipePower = (offset, velocity) => {
	return Math.abs(offset) * velocity;
};

export { variants, swipeConfidenceThreshold, swipePower };
